import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AIDashboard() {
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInsights = async () => {
      try {
        const res = await fetch("/api/ai", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            type: "agents",
            userId: "demo-user"
          })
        });

        const data = await res.json();
        setInsights(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchInsights();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <p className="text-cyan-400 animate-pulse">🧠 Loading AI Dashboard...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-zinc-900 to-black text-white px-4 py-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-lg font-bold text-cyan-300">🧠 AI Dashboard</h1>
        <button
          onClick={() => navigate(-1)}
          className="text-xs bg-gray-800 px-3 py-1 rounded-lg"
        >
          ⬅ Back
        </button>
      </div>

      {/* Strategy */}
      <div className="bg-indigo-900/40 border border-indigo-500 rounded-2xl p-4 mb-3">
        <p className="text-indigo-300 text-sm mb-1">⚔️ Strategy Insight</p>
        <p className="text-xs text-gray-200">
          {insights?.strategy || "No data"}
        </p>
      </div>

      {/* Cognitive */}
      <div className="bg-yellow-900/40 border border-yellow-500 rounded-2xl p-4 mb-3">
        <p className="text-yellow-300 text-sm mb-1">🧠 Cognitive Profile</p>
        <p className="text-xs text-gray-200">
          {insights?.profile || "No data"}
        </p>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="bg-green-900/40 border border-green-500 rounded-xl p-3 text-center">
          <p className="text-green-300 text-xs">Accuracy</p>
          <p className="text-lg font-bold">--%</p>
        </div>

        <div className="bg-red-900/40 border border-red-500 rounded-xl p-3 text-center">
          <p className="text-red-300 text-xs">Mistakes</p>
          <p className="text-lg font-bold">--</p>
        </div>
      </div>

      {/* Action Plan */}
      <div className="bg-green-900/30 border border-green-500 rounded-2xl p-4 mb-4">
        <p className="text-green-300 text-sm mb-2">📈 AI Action Plan</p>
        <ul className="text-xs text-gray-200 space-y-1 list-disc ml-4">
          <li>Revise weak topics daily</li>
          <li>Avoid overthinking in easy questions</li>
          <li>Improve time management</li>
        </ul>
      </div>

      {/* CTA */}
      <button
        onClick={() => navigate("/examunion-practice")}
        className="w-full bg-gradient-to-r from-cyan-500 to-indigo-500 py-3 rounded-xl font-semibold text-sm"
      >
        🚀 Improve Now
      </button>
    </div>
  );
}
